import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from '@angular/common';
import { CustomDownloadsComponent } from './custom-downloads.component';
import { CustomUploadsComponent } from '../custom-uploads/custom-uploads.component';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { UploadModule } from "@progress/kendo-angular-upload";
import { ImportFileComponent } from "../import-file/import-file.component";
import { SharedComponentsModule } from "../../sharedComponents.module";

@NgModule({
  imports: [
        CommonModule,
        DialogsModule,
        ButtonsModule,
        UploadModule,
        SharedComponentsModule,

  ],
    declarations: [
        CustomDownloadsComponent,
        CustomUploadsComponent,
        ImportFileComponent,

    ],
  exports: [
      CustomDownloadsComponent,
      CustomUploadsComponent,
      ImportFileComponent,

  ]
})
export class CustomDownloadModule {}
